var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 55,
    height: 55,
    rx: 11.5,
    stroke: "#E03137"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26 19.75C25.9337 19.75 25.8701 19.7763 25.8232 19.8232C25.7763 19.8701 25.75 19.9337 25.75 20V22.25H30.25V20C30.25 19.9337 30.2237 19.8701 30.1768 19.8232C30.1299 19.7763 30.0663 19.75 30 19.75H26ZM21.8151 23.75L22.7474 34.9377C22.7491 34.9584 22.75 34.9792 22.75 35C22.75 35.3315 22.8817 35.6495 23.1161 35.8839C23.3505 36.1183 23.6685 36.25 24 36.25H32C32.3315 36.25 32.6495 36.1183 32.8839 35.8839C33.1183 35.6495 33.25 35.3315 33.25 35C33.25 34.9792 33.2509 34.9584 33.2526 34.9377L34.1849 23.75H21.8151ZM35.6901 23.75L34.7498 35.0337C34.741 35.7508 34.4523 36.4368 33.9445 36.9445C33.4288 37.4603 32.7293 37.75 32 37.75H24C23.2707 37.75 22.5712 37.4603 22.0555 36.9445C21.5477 36.4368 21.259 35.7508 21.2502 35.0337L20.3099 23.75H20C19.5858 23.75 19.25 23.4142 19.25 23C19.25 22.5858 19.5858 22.25 20 22.25H24.25V20C24.25 19.5359 24.4344 19.0908 24.7626 18.7626C25.0908 18.4344 25.5359 18.25 26 18.25H30C30.4641 18.25 30.9092 18.4344 31.2374 18.7626C31.5656 19.0908 31.75 19.5359 31.75 20V22.25H36C36.4142 22.25 36.75 22.5858 36.75 23C36.75 23.4142 36.4142 23.75 36 23.75H35.6901ZM26 26.25C26.4142 26.25 26.75 26.5858 26.75 27V33C26.75 33.4142 26.4142 33.75 26 33.75C25.5858 33.75 25.25 33.4142 25.25 33V27C25.25 26.5858 25.5858 26.25 26 26.25ZM30 26.25C30.4142 26.25 30.75 26.5858 30.75 27V33C30.75 33.4142 30.4142 33.75 30 33.75C29.5858 33.75 29.25 33.4142 29.25 33V27C29.25 26.5858 29.5858 26.25 30 26.25Z",
    fill: "#E03137"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteButton);
export default __webpack_public_path__ + "static/media/DeleteButton.611ea1b544b542c48c3fa59b09487879.svg";
export { ForwardRef as ReactComponent };